import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TurbineComponent } from './turbine/turbine.component';

@Component({
  selector: 'importer-app-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrls: ['./loading-screen.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TurbineComponent]
})
export class LoadingScreenComponent {
  @Input() local?: boolean;
  @Input() contrast?: boolean;

  constructor() {}
}
